import React from "react"
import HTMLReactParser from 'html-react-parser';
import useDeviceMedia from "../../utils/useDeviceMedia";
import ReadMoreComponent from "../../ReadMore/ReadMore";
import "./StaticContent.scss";

const StaticContent = ({ content, ShowReadMoreMobile }) => {
    const { isCustomMax } = useDeviceMedia({ max: "767.98px" });
    
    return (
        <section className="static-page-static-content text-sm">
            {isCustomMax && ShowReadMoreMobile ? (
                <ReadMoreComponent content={content} wrapclass="readmore-wrap mobile-readmore-wrap text-sm" />
            ) : (
                HTMLReactParser(content.replace(/<br\s*[\/]?>/gi, ""))
            )}
        </section>
    );
};
export default StaticContent